/**
 * Relatorios Module Routes
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

// Lazy load components
const ListaCustomizados = lazy(() => import("@/pages/relatorios/ListaCustomizados"));
const ReportDesigner = lazy(() => import("@/pages/relatorios/ReportDesigner"));
const ReportExecutor = lazy(() => import("@/pages/relatorios/ReportExecutor"));
const DashboardKpis = lazy(() => import("@/pages/relatorios/DashboardKpis"));
const IndicadoresDocumentais = lazy(() => import("@/pages/relatorios/IndicadoresDocumentais"));
const PainelExecutivo = lazy(() => import("@/pages/relatorios/PainelExecutivo"));
const PainelComplianceSla = lazy(() => import("@/pages/relatorios/PainelComplianceSla"));

export const relatoriosRoutes: ModuleRoutes = {
  moduleId: "relatorios",
  basePath: "/relatorios",
  routes: [
    {
      path: "/relatorios/customizados",
      element: <ListaCustomizados />,
      permission: { resource: "relatorios", action: "customizados_view" },
    },
    {
      path: "/relatorios/designer",
      element: <ReportDesigner />,
      permission: { resource: "relatorios", action: "designer_view" },
    },
    {
      path: "/relatorios/executar/:id",
      element: <ReportExecutor />,
      permission: { resource: "relatorios", action: "customizados_view" },
    },
    {
      path: "/relatorios/kpis",
      element: <DashboardKpis />,
      permission: { resource: "relatorios", action: "kpis_view" },
    },
    {
      path: "/relatorios/documentais",
      element: <IndicadoresDocumentais />,
      permission: { resource: "relatorios", action: "documentais_view" },
    },
    {
      path: "/relatorios/executivo",
      element: <PainelExecutivo />,
      permission: { resource: "relatorios", action: "executivo_view" },
    },
    {
      path: "/relatorios/compliance-sla",
      element: <PainelComplianceSla />,
      permission: { resource: "relatorios", action: "compliance_view" },
    },
  ],
};
